export default __webpack_public_path__ + "static/media/about-image.beea0985.jpg";